import React from 'react';
import { Facebook, Instagram, Twitter, Youtube, Whatsapp, Messenger } from '@menuzen/icon/build/outline';
import {
    Facebook as FacebookShape,
    Instagram as InstagramShape,
    Twitter as TwitterShape,
    Youtube as YoutubeShape,
    Whatsapp as WhatsappShape,
    Messenger as MessengerShape,
} from '@menuzen/icon/build/shape';
import {
    Facebook as FacebookSolid,
    Instagram as InstagramSolid,
    Twitter as TwitterSolid,
    Youtube as YoutubeSolid,
    Whatsapp as WhatsappSolid,
    Messenger as MessengerSolid,
} from '@menuzen/icon/build/solid';

export interface SocialOptionData {
    value: string;
    title: string;
    placeholder?: string;
    outlineIcon?: React.ReactElement;
    shapeIcon?: React.ReactElement;
    solidIcon?: React.ReactElement;
    valueType: SocialValueType;
    prefix?: string[]; // for auto correct
    handleLink?: (value: string) => string;
}
export enum SocialValueType {
    LINK = 'link',
    USERNAME = 'username',
    PHONE = 'phone',
}
export const socialOptions: SocialOptionData[] = [
    {
        value: 'FACEBOOK',
        outlineIcon: <Facebook />,
        shapeIcon: <FacebookShape />,
        solidIcon: <FacebookSolid />,
        valueType: SocialValueType.LINK,
        prefix: ['facebook.com', 'fb.com'],
        title: 'Facebook',
        placeholder: 'https://www.facebook.com/username',
    },
    {
        value: 'INSTAGRAM',
        valueType: SocialValueType.USERNAME,
        outlineIcon: <Instagram />,
        shapeIcon: <InstagramShape />,
        solidIcon: <InstagramSolid />,
        title: 'Instagram',
        placeholder: 'username or url',
    },
    {
        value: 'YOUTUBE',
        title: 'Youtube',
        valueType: SocialValueType.LINK,
        prefix: ['youtube.com', 'youtu.be'],
        outlineIcon: <Youtube />,
        shapeIcon: <YoutubeShape />,
        solidIcon: <YoutubeSolid />,
        placeholder: 'https://www.youtube.com/channel/username',
    },
    {
        value: 'TWITTER',
        title: 'Twitter',
        valueType: SocialValueType.USERNAME,
        outlineIcon: <Twitter />,
        shapeIcon: <TwitterShape />,
        solidIcon: <TwitterSolid />,
        placeholder: 'username or url',
    },
    {
        value: 'WHATSAPP',
        title: 'Whatsapp',
        valueType: SocialValueType.PHONE,
        outlineIcon: <Whatsapp />,
        shapeIcon: <WhatsappShape />,
        solidIcon: <WhatsappSolid />,
        placeholder: '+254 000 12345',
        handleLink: (val) => {
            if (val) {
                if (val.startsWith('http')) {
                    return val;
                }
                return `https://wa.me/${val.replace(/[-\(\) + ]/g, '')}`;
            }
            return '';
        },
    },
    {
        value: 'FACEBOOK_MESSENGER',
        title: 'Facebook Messenger',
        valueType: SocialValueType.USERNAME,
        outlineIcon: <Messenger />,
        shapeIcon: <MessengerShape />,
        solidIcon: <MessengerSolid />,
        placeholder: 'facebookusername',
        handleLink: (val) => {
            if (val) {
                if (val.startsWith('http')) {
                    return val;
                }
                return `https://m.me/${val}`;
            }
            return '';
        },
    },
];
